var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12 mb-11 ml-n6" } },
                    [
                      _c(
                        "v-stepper",
                        {
                          attrs: { backgroud: "" },
                          model: {
                            value: _vm.step,
                            callback: function ($$v) {
                              _vm.step = $$v
                            },
                            expression: "step",
                          },
                        },
                        [
                          _c(
                            "v-stepper-header",
                            [
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: { complete: _vm.step > 1, step: "1" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.AlterarPasso(1)
                                    },
                                  },
                                },
                                [_vm._v(" CNPJ e Razão Social ")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: { complete: _vm.step > 2, step: "2" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.AlterarPasso(2)
                                    },
                                  },
                                },
                                [_vm._v(" Dados do Corretor ")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: { complete: _vm.step > 3, step: "3" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.AlterarPasso(3)
                                    },
                                  },
                                },
                                [_vm._v(" Informações Gerais ")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: { complete: _vm.step > 4, step: "4" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.AlterarPasso(4)
                                    },
                                  },
                                },
                                [_vm._v(" Usuário Master Portal EZZE ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step == 1,
                      expression: "step == 1",
                    },
                  ],
                  attrs: { id: "etapa1" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n9",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["##.###.###/####-##"],
                            expression: "['##.###.###/####-##']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required, _vm.rules.validarCnpj],
                          label: "CNPJ",
                          loading: _vm.loadingCnpj,
                          color: "#007681",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.PesquisarCNPJ()
                          },
                        },
                        model: {
                          value: _vm.cnpj,
                          callback: function ($$v) {
                            _vm.cnpj = $$v
                          },
                          expression: "cnpj",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n9",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["###########"],
                            expression: "['###########']",
                          },
                        ],
                        attrs: {
                          readonly: true,
                          label: "NÚMERO SUSEP",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.numeroSusep,
                          callback: function ($$v) {
                            _vm.numeroSusep = $$v
                          },
                          expression: "numeroSusep",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "12" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { color: "black !important" },
                        attrs: {
                          readonly: true,
                          label: "RAZÃO SOCIAL",
                          color: "#007681",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.razaoSocial,
                          callback: function ($$v) {
                            _vm.razaoSocial = $$v
                          },
                          expression: "razaoSocial",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#####-###"],
                            expression: "['#####-###']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "CEP",
                          color: "#007681",
                        },
                        on: { input: _vm.BuscarCep },
                        model: {
                          value: _vm.cep,
                          callback: function ($$v) {
                            _vm.cep = $$v
                          },
                          expression: "cep",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "5", lg: "5" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "LOGRADOURO",
                          color: "#007681",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.logradouro,
                          callback: function ($$v) {
                            _vm.logradouro = $$v
                          },
                          expression: "logradouro",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "1", lg: "1" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["########"],
                            expression: "['########']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "Nº",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.numero,
                          callback: function ($$v) {
                            _vm.numero = $$v
                          },
                          expression: "numero",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "COMPLEMENTO",
                          color: "#007681",
                          maxlength: "80",
                        },
                        model: {
                          value: _vm.complemento,
                          callback: function ($$v) {
                            _vm.complemento = $$v
                          },
                          expression: "complemento",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "3", lg: "3" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "BAIRRO",
                          maxlength: "40",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.bairro,
                          callback: function ($$v) {
                            _vm.bairro = $$v
                          },
                          expression: "bairro",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "9",
                        lg: "9",
                        id: "col-Assessoria",
                      },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          color: "#007681",
                          rules: [_vm.rules.required],
                          loading: _vm.loading,
                          items: _vm.cidades,
                          "search-input": _vm.search,
                          "cache-items": true,
                          label: "CIDADE",
                          "item-text": "nomeCidade",
                          "item-value": "idCidade",
                          "hide-no-data": "",
                          "hide-selected": "",
                          clearable: "",
                          "return-object": "",
                        },
                        on: {
                          "update:searchInput": function ($event) {
                            _vm.search = $event
                          },
                          "update:search-input": function ($event) {
                            _vm.search = $event
                          },
                        },
                        model: {
                          value: _vm.cidade,
                          callback: function ($$v) {
                            _vm.cidade = $$v
                          },
                          expression: "cidade",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "5", lg: "5" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(2)
                            },
                          },
                        },
                        [_vm._v(" PRÓXIMA ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "5", lg: "5" },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step == 2,
                      expression: "step == 2",
                    },
                  ],
                  attrs: { id: "etapa2" },
                },
                [
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("ASSESSORIA")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "12" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("div", [_vm._v("Possui Assessoria?")])]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "", rules: [_vm.rules.required] },
                          on: { change: _vm.PossuiAssessoria },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", [_vm._v("Possui Assessoria?")]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.possuiAssessoria,
                            callback: function ($$v) {
                              _vm.possuiAssessoria = $$v
                            },
                            expression: "possuiAssessoria",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Sim", value: "true" },
                          }),
                          _c("v-radio", {
                            attrs: { label: "Não", value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.assessoriaShow,
                          expression: "assessoriaShow",
                        },
                      ],
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          color: "#007681",
                          rules:
                            _vm.possuiAssessoria == [true]
                              ? [_vm.rules.required]
                              : [],
                          loading: _vm.loadingAssessoria,
                          items: _vm.assessoriaItem,
                          "search-input": _vm.searchAssessoria,
                          "cache-items": true,
                          label: "Assessoria",
                          placeholder: "Digite o nome da assessoria",
                          "item-text": "nm_pessoa",
                          "item-value": "id_pessoa",
                          "hide-no-data": "",
                          "hide-selected": "",
                          clearable: "",
                          "return-object": "",
                        },
                        on: {
                          "update:searchInput": function ($event) {
                            _vm.searchAssessoria = $event
                          },
                          "update:search-input": function ($event) {
                            _vm.searchAssessoria = $event
                          },
                        },
                        model: {
                          value: _vm.assessoria,
                          callback: function ($$v) {
                            _vm.assessoria = $$v
                          },
                          expression: "assessoria",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("DADOS BANCARIOS")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          rules: [_vm.rules.required],
                          "item-text": "nm_banco",
                          "item-value": "nr_banco",
                          items: _vm.bancosjson,
                          label: "BANCO",
                          "return-object": "",
                          color: "#007681",
                          "item-props": "true",
                        },
                        model: {
                          value: _vm.banco,
                          callback: function ($$v) {
                            _vm.banco = $$v
                          },
                          expression: "banco",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#########"],
                            expression: "['#########']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "AGÊNCIA/DÍGITO",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.agenciaDigito,
                          callback: function ($$v) {
                            _vm.agenciaDigito = $$v
                          },
                          expression: "agenciaDigito",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#########"],
                            expression: "['#########']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "CONTA/DÍGITO",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.contaDigito,
                          callback: function ($$v) {
                            _vm.contaDigito = $$v
                          },
                          expression: "contaDigito",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "mt-n8", attrs: { cols: "12" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: "Utilizar o mesmo endereço para cobrança?",
                          color: "#007681",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.UtilizarMesmoEndereco()
                          },
                          blur: function ($event) {
                            return _vm.UtilizarMesmoEndereco()
                          },
                        },
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#####-###"],
                            expression: "['#####-###']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "CEP",
                          color: "#007681",
                        },
                        on: {
                          input: _vm.BuscarCepCobranca,
                          change: _vm.BuscarCepCobranca,
                        },
                        model: {
                          value: _vm.cepCobranca,
                          callback: function ($$v) {
                            _vm.cepCobranca = $$v
                          },
                          expression: "cepCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "5", lg: "5" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "LOGRADOURO",
                          color: "#007681",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.logradouroCobranca,
                          callback: function ($$v) {
                            _vm.logradouroCobranca = $$v
                          },
                          expression: "logradouroCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "1", lg: "1" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["########"],
                            expression: "['########']",
                          },
                        ],
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "Nº",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.numeroCobranca,
                          callback: function ($$v) {
                            _vm.numeroCobranca = $$v
                          },
                          expression: "numeroCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "COMPLEMENTO",
                          color: "#007681",
                          maxlength: "80",
                        },
                        model: {
                          value: _vm.complementoCobranca,
                          callback: function ($$v) {
                            _vm.complementoCobranca = $$v
                          },
                          expression: "complementoCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "3", lg: "3" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required],
                          label: "BAIRRO",
                          maxlength: "40",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.bairroCobranca,
                          callback: function ($$v) {
                            _vm.bairroCobranca = $$v
                          },
                          expression: "bairroCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "9", lg: "9" },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          color: "#007681",
                          rules: [_vm.rules.required],
                          loading: _vm.loadingCobranca,
                          items: _vm.cidadesCobranca,
                          "search-input": _vm.searchCobranca,
                          "cache-items": true,
                          label: "CIDADE",
                          "item-text": "nomeCidade",
                          "item-value": "idCidade",
                          "hide-no-data": "",
                          "hide-selected": "",
                          clearable: "",
                          "return-object": "",
                        },
                        on: {
                          "update:searchInput": function ($event) {
                            _vm.searchCobranca = $event
                          },
                          "update:search-input": function ($event) {
                            _vm.searchCobranca = $event
                          },
                        },
                        model: {
                          value: _vm.cidadeCobranca,
                          callback: function ($$v) {
                            _vm.cidadeCobranca = $$v
                          },
                          expression: "cidadeCobranca",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("CONTATOS")]),
                  ]),
                  _vm._l(_vm.contatos, function (item) {
                    return _c(
                      "v-container",
                      { key: item.id, attrs: { "max-width": "100%" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "6",
                                  lg: "6",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    rules: [_vm.rules.required],
                                    label: "NOME",
                                    maxlength: "75",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.nome,
                                    callback: function ($$v) {
                                      _vm.$set(item, "nome", $$v)
                                    },
                                    expression: "item.nome",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "6",
                                  lg: "6",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "E-MAIL",
                                    rules: [
                                      _vm.rules.required,
                                      _vm.rules.email,
                                    ],
                                    maxlength: "75",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.email,
                                    callback: function ($$v) {
                                      _vm.$set(item, "email", $$v)
                                    },
                                    expression: "item.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "6",
                                  lg: "6",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value:
                                        item.telefone.length >= 15
                                          ? ["(##) #####-####"]
                                          : ["(##) ####-####"],
                                      expression:
                                        "(item.telefone.length >= 15) ? ['(##) #####-####'] : ['(##) ####-####']",
                                    },
                                  ],
                                  attrs: {
                                    rules: [_vm.rules.required],
                                    label: "TELEFONE",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.telefone,
                                    callback: function ($$v) {
                                      _vm.$set(item, "telefone", $$v)
                                    },
                                    expression: "item.telefone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "6",
                                  lg: "6",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "CARGO",
                                    rules: [_vm.rules.required],
                                    maxlength: "75",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.cargo,
                                    callback: function ($$v) {
                                      _vm.$set(item, "cargo", $$v)
                                    },
                                    expression: "item.cargo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5 align-md-center",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "#303030", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.AdicionarContato()
                            },
                          },
                        },
                        [_vm._v("ADICIONAR NOVO CONTATO")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("GRUPO DE CORRETOR")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "12" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", [_vm._v("Possui Grupo de Corretor?")]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "", rules: [_vm.rules.required] },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm._v("Possui Grupo de Corretor?"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.possuiGrupoCorretor,
                            callback: function ($$v) {
                              _vm.possuiGrupoCorretor = $$v
                            },
                            expression: "possuiGrupoCorretor",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Sim", value: "true" },
                          }),
                          _c("v-radio", {
                            attrs: { label: "Não", value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.possuiGrupoCorretor == [true],
                          expression: "possuiGrupoCorretor == [true]",
                        },
                      ],
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "12" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("div", [_vm._v("Corretor Líder?")])]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: {
                            row: "",
                            rules:
                              _vm.possuiGrupoCorretor == [true]
                                ? [_vm.rules.required]
                                : [],
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [_c("div", [_vm._v("Corretor Líder?")])]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.corretorLider,
                            callback: function ($$v) {
                              _vm.corretorLider = $$v
                            },
                            expression: "corretorLider",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Sim", value: "true" },
                          }),
                          _c("v-radio", {
                            attrs: { label: "Não", value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.corretorLider == [false] &&
                            _vm.possuiGrupoCorretor == [true],
                          expression:
                            "corretorLider == [false] && possuiGrupoCorretor == [true]",
                        },
                      ],
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["##.###.###/####-##"],
                            expression: "['##.###.###/####-##']",
                          },
                        ],
                        attrs: {
                          rules:
                            _vm.corretorLider == [false] &&
                            _vm.possuiGrupoCorretor == [true]
                              ? [_vm.rules.required, _vm.rules.validarCnpj]
                              : [],
                          label: "CNPJ CORRETORA LÍDER",
                          loading: _vm.loadingCnpjCorretorLider,
                          color: "#007681",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.PesquisarCNPJCorretoraLider()
                          },
                        },
                        model: {
                          value: _vm.cnpjCorretorLider,
                          callback: function ($$v) {
                            _vm.cnpjCorretorLider = $$v
                          },
                          expression: "cnpjCorretorLider",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.corretorLider == [false] &&
                            _vm.possuiGrupoCorretor == [true],
                          expression:
                            "corretorLider == [false] && possuiGrupoCorretor == [true]",
                        },
                      ],
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { color: "black !important" },
                        attrs: {
                          readonly: true,
                          label: "RAZÃO SOCIAL CORRETORA LÍDER",
                          color: "#007681",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.razaoSocialCorretorLider,
                          callback: function ($$v) {
                            _vm.razaoSocialCorretorLider = $$v
                          },
                          expression: "razaoSocialCorretorLider",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(1)
                            },
                          },
                        },
                        [_vm._v(" VOLTAR ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(3)
                            },
                          },
                        },
                        [_vm._v(" PRÓXIMA ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                ],
                2
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step == 3,
                      expression: "step == 3",
                    },
                  ],
                  attrs: { id: "etapa3" },
                },
                [
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("INFORMAÇÕES GERAIS")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "item-text": "valor",
                          "item-value": "valor",
                          items: _vm.lstTempoAtuacao,
                          label: "TEMPO DE ATUAÇÃO",
                          "return-object": "",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.tempoAtuacao,
                          callback: function ($$v) {
                            _vm.tempoAtuacao = $$v
                          },
                          expression: "tempoAtuacao",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "item-text": "valor",
                          "item-value": "valor",
                          items: _vm.lstQtdFuncionarios,
                          label: "Nº DE FUNCIONÁRIOS DA CORRETORA",
                          "return-object": "",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.numeroFuncionarios,
                          callback: function ($$v) {
                            _vm.numeroFuncionarios = $$v
                          },
                          expression: "numeroFuncionarios",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "money",
                            rawName: "v-money",
                            value: _vm.money,
                            expression: "money",
                          },
                        ],
                        attrs: {
                          label: "MÉDIA DE PRÊMIO EMITIDO MENSAL",
                          prefix: "R$",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.mediaPremioEmitidoMensal,
                          callback: function ($$v) {
                            _vm.mediaPremioEmitidoMensal = $$v
                          },
                          expression: "mediaPremioEmitidoMensal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("ESTADOS DE ATUAÇÃO")]),
                  ]),
                  _vm._l(_vm.estadosAtuacao, function (item) {
                    return _c(
                      "v-container",
                      { key: item.id, attrs: { "max-width": "100%" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                },
                              },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    "item-text": "valor",
                                    "item-value": "valor",
                                    items: _vm.lstEstados,
                                    label: "SELECIONE UM ESTADO",
                                    "return-object": "",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.valor,
                                    callback: function ($$v) {
                                      _vm.$set(item, "valor", $$v)
                                    },
                                    expression: "item.valor",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5 align-md-center",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "#303030", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.AdicionarEstado()
                            },
                          },
                        },
                        [_vm._v("ADICIONAR NOVO ESTADO")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "12" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", [
                                _vm._v(
                                  "Utiliza sistema de multicalculo e/ou gestão?"
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "Utiliza sistema de multicalculo e/ou gestão?"
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.utilizaSistemaMulticalculo,
                            callback: function ($$v) {
                              _vm.utilizaSistemaMulticalculo = $$v
                            },
                            expression: "utilizaSistemaMulticalculo",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Sim", value: "true" },
                          }),
                          _c("v-radio", {
                            attrs: { label: "Não", value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.utilizaSistemaMulticalculo == [true],
                          expression: "utilizaSistemaMulticalculo == [true]",
                        },
                      ],
                      staticClass: "mt-n1",
                      attrs: { cols: "12" },
                    },
                    [_c("h4", [_vm._v("SISTEMAS UTILIZADOS")])]
                  ),
                  _vm._l(_vm.sistemaMulticalculo, function (item) {
                    return _c(
                      "v-container",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.utilizaSistemaMulticalculo == [true],
                            expression: "utilizaSistemaMulticalculo == [true]",
                          },
                        ],
                        key: item.id,
                        attrs: { "max-width": "100%" },
                      },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                },
                              },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    "item-text": "valor",
                                    "item-value": "valor",
                                    items: _vm.listSistemaMulticalculo,
                                    label: "SELECIONE UM SISTEMA",
                                    "return-object": "",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.valor,
                                    callback: function ($$v) {
                                      _vm.$set(item, "valor", $$v)
                                    },
                                    expression: "item.valor",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.valor.valor == "Outros",
                                    expression: "item.valor.valor == 'Outros'",
                                  },
                                ],
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      "INSIRA AQUI O(S) SISTEMA(S) UTILIZADO(S)",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.valor.descricao,
                                    callback: function ($$v) {
                                      _vm.$set(item.valor, "descricao", $$v)
                                    },
                                    expression: "item.valor.descricao",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.utilizaSistemaMulticalculo == [true],
                        expression: "utilizaSistemaMulticalculo == [true]",
                      },
                    ],
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.utilizaSistemaMulticalculo == [true],
                          expression: "utilizaSistemaMulticalculo == [true]",
                        },
                      ],
                      staticClass: "mt-n5 align-md-center",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "#303030", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.AdicionarSistema()
                            },
                          },
                        },
                        [_vm._v("ADICIONAR NOVO SISTEMA")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.utilizaSistemaMulticalculo == [true],
                        expression: "utilizaSistemaMulticalculo == [true]",
                      },
                    ],
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("PRINCIPAIS LINHAS DE PRODUTO")]),
                  ]),
                  _vm._l(_vm.principaisLinhasProduto, function (item) {
                    return _c(
                      "v-container",
                      { key: item.id, attrs: { "max-width": "100%" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                },
                              },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    "item-text": "valor",
                                    "item-value": "valor",
                                    items: _vm.linhasProduto,
                                    label: "SELECIONE UMA LINHA DE PRODUTO",
                                    "return-object": "",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.valor,
                                    callback: function ($$v) {
                                      _vm.$set(item, "valor", $$v)
                                    },
                                    expression: "item.valor",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.valor.valor == "Outros",
                                    expression: "item.valor.valor == 'Outros'",
                                  },
                                ],
                                staticClass: "mt-n5",
                                attrs: {
                                  cols: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      "INSIRA AQUI A(S) LINHAS(S) DE PRODUTO NÃO LISTADA(S)",
                                    color: "#007681",
                                  },
                                  model: {
                                    value: item.valor.descricao,
                                    callback: function ($$v) {
                                      _vm.$set(item.valor, "descricao", $$v)
                                    },
                                    expression: "item.valor.descricao",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5 align-md-center",
                      attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "#303030", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.AdicionarLinhaProduto()
                            },
                          },
                        },
                        [_vm._v(" ADICIONAR NOVA LINHA DE PRODUTO ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "mt-n5 align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(2)
                            },
                          },
                        },
                        [_vm._v(" VOLTAR ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(4)
                            },
                          },
                        },
                        [_vm._v(" PRÓXIMA ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                ],
                2
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step == 4,
                      expression: "step == 4",
                    },
                  ],
                  attrs: { id: "etapa4" },
                },
                [
                  _c("v-col", { staticClass: "mt-n1", attrs: { cols: "12" } }, [
                    _c("h4", [_vm._v("USÚARIO MASTER PORTAL")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required],
                          readonly: true,
                          label: "NOME",
                          maxlength: "75",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.nomeUsuario,
                          callback: function ($$v) {
                            _vm.nomeUsuario = $$v
                          },
                          expression: "nomeUsuario",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n5",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required, _vm.rules.email],
                          label: "E-MAIL",
                          maxlength: "75",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.emailUsuario,
                          callback: function ($$v) {
                            _vm.emailUsuario = $$v
                          },
                          expression: "emailUsuario",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "LOGIN(SUSEP)",
                          readonly: true,
                          maxlength: "75",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.login,
                          callback: function ($$v) {
                            _vm.login = $$v
                          },
                          expression: "login",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n8",
                      attrs: { cols: "12", sm: "12", md: "6", lg: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "SENHA",
                          readonly: true,
                          maxlength: "75",
                          color: "#007681",
                        },
                        model: {
                          value: _vm.senha,
                          callback: function ($$v) {
                            _vm.senha = $$v
                          },
                          expression: "senha",
                        },
                      }),
                    ],
                    1
                  ),
                  false
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { wi: "", "max-width": "800" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { attrs: { "three-line": "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "headline mb-1" },
                                        [_vm._v("Microseguros")]
                                      ),
                                      _c("v-list-item-subtitle", {
                                        staticClass: "wrap-text",
                                        attrs: { "three-line": "" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-switch", {
                                    attrs: { readonly: true },
                                    model: {
                                      value: _vm.microsseguros,
                                      callback: function ($$v) {
                                        _vm.microsseguros = $$v
                                      },
                                      expression: "microsseguros",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { "max-width": "800" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { attrs: { "three-line": "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "headline mb-1" },
                                        [_vm._v(" Planos de Capitalização ")]
                                      ),
                                      _c("v-list-item-subtitle", {
                                        staticClass: "wrap-text",
                                        attrs: { "three-line": "" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-switch", {
                                    attrs: { readonly: true },
                                    model: {
                                      value: _vm.planosDeCapitalizacao,
                                      callback: function ($$v) {
                                        _vm.planosDeCapitalizacao = $$v
                                      },
                                      expression: "planosDeCapitalizacao",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { "max-width": "800" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { attrs: { "three-line": "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "headline mb-1" },
                                        [
                                          _vm._v(
                                            " Planos de Previdência Complementar "
                                          ),
                                        ]
                                      ),
                                      _c("v-list-item-subtitle", {
                                        staticClass: "wrap-text",
                                        attrs: { "three-line": "" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-switch", {
                                    attrs: { readonly: true },
                                    model: {
                                      value:
                                        _vm.planosDePrevidenciaComplementar,
                                      callback: function ($$v) {
                                        _vm.planosDePrevidenciaComplementar =
                                          $$v
                                      },
                                      expression:
                                        "planosDePrevidenciaComplementar",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { "max-width": "800" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { attrs: { "three-line": "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "headline mb-1" },
                                        [_vm._v("Seguro de Danos")]
                                      ),
                                      _c("v-list-item-subtitle", {
                                        staticClass: "wrap-text",
                                        attrs: { "three-line": "" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-switch", {
                                    attrs: { readonly: true },
                                    model: {
                                      value: _vm.seguroDeDano,
                                      callback: function ($$v) {
                                        _vm.seguroDeDano = $$v
                                      },
                                      expression: "seguroDeDano",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: { "max-width": "800" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { attrs: { "three-line": "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "headline mb-1" },
                                        [_vm._v("Seguro de Pessoas")]
                                      ),
                                      _c("v-list-item-subtitle", {
                                        staticClass: "wrap-text",
                                        attrs: { "three-line": "" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-switch", {
                                    attrs: { readonly: true },
                                    model: {
                                      value: _vm.seguroDePessoas,
                                      callback: function ($$v) {
                                        _vm.seguroDePessoas = $$v
                                      },
                                      expression: "seguroDePessoas",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.AlterarPasso(3)
                            },
                          },
                        },
                        [_vm._v(" VOLTAR ETAPA ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-md-center",
                      attrs: { cols: "12", sm: "12", md: "2", lg: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingBtn,
                            block: "",
                            color: "#303030",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.ConsultaScoreBureau(
                                _vm.cnpj
                                  .replace(".", "")
                                  .replace("/", "")
                                  .replace("-", "")
                                  .replace(".", ""),
                                _vm.FinalizarCadastro
                              )
                            },
                          },
                        },
                        [_vm._v(" FINALIZAR CADASTRO ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-col", {
                    staticClass: "align-md-center",
                    attrs: { cols: "12", sm: "12", md: "4", lg: "4" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "355", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", {
                staticClass: "headline",
                domProps: { textContent: _vm._s(_vm.dialogTitle) },
              }),
              _c("v-card-text", {
                domProps: { textContent: _vm._s(_vm.messageDialog) },
              }),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm.dialogLink
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#007681",
                            text: "",
                            href: "https://ezzeseguros.com.br/fale-conosco.html",
                          },
                          on: {
                            click: function ($event) {
                              _vm.dialogLink = false
                            },
                          },
                        },
                        [_vm._v(" Fale Conosco ")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#007681", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v(" Fechar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }